import {useState} from "react";
import {InfiniteScroll} from "@inertiajs/react";
import {Product} from "@/entities/product";
import {Button} from "@/shared/ui/Button";
import {CatalogCard} from "@/widgets/catalog-card";
import styles from "./MainRecommendedProducts.module.scss";

type RecommendedProducts = {
    data: Product[];
};

type Props = {
    titleSection: string;
    recommended: RecommendedProducts;
}

export const MainRecommendedProducts = ({titleSection, recommended}: Props) => {
    const [autoMode, setAutoMode] = useState(false);

    const handleLoadMore = (fetch: () => void) => {
        fetch();
        setAutoMode(true);
    };

    return (
        <div className={`globalContainer`}>
            <div className={styles.container}>
                <p className={styles.titleSection}>{titleSection}</p>
                <InfiniteScroll
                    data={`recommendedProducts`}
                    className={styles.cards}
                    buffer={600}
                    preserveUrl
                    manual={!autoMode}
                    next={({loading, fetch, hasMore}) =>
                        hasMore && !autoMode && (
                            <Button
                                variant={`tertiary`}
                                disabled={loading}
                                onClick={() => handleLoadMore(fetch)}
                                fullWidth
                            >
                                {loading ? "Загрузка..." : "Смотреть ещё"}
                            </Button>
                        )}
                >
                    {recommended?.data?.map(product => (
                        <CatalogCard
                            key={product.id}
                            product={product}
                            className={styles.card}
                        />
                    ))}
                </InfiniteScroll>
            </div>
        </div>
    );
}
